<template>
  <div>
    <field-wrapper label="Type" v-model="values.type" :options="options.placeRangeTypes" :error="errors.range"
                   type="select"/>
    <div class="text-muted">
      <div>
        <code>scope</code> results will contain events that apply to the parent and children places of the
        specified place. E.g. National, regional and local school holidays that apply to a region.
      </div>
      <br/>
      <div>
        <code>exact</code> results will contain events that apply to the specified place only. E.g. Regional
        school holidays only.
      </div>
    </div>
    <br/>
    <field-wrapper label="Place" v-model="values.places" :options="placeOptions" :error="errors.places" track-by="value"
                   type="select" description="Location that the event takes/took place in." :multiple="true"
                   option-label="label" inputPlaceholder="Start typing" @search-change="onPlaceChange" internalSearch/>
  </div>
</template>
<script>
  import fieldWrapper from '@/components/shared/field-wrapper'
  import PlacesAPI from '@/app/api/phq-public/places'
  import { FILTER_OPTIONS } from '@/app/wdc/form/fixtures'
  import lodash from 'lodash'
  import Vue from 'vue'

  export default {
    components: {
      fieldWrapper
    },
    props: {
      values: Object,
      errors: Object
    },
    name: 'placeFilter',
    data () {
      return {
        options: FILTER_OPTIONS,
        placeOptions: []
      }
    },
    methods: {
      onPlaceChange: lodash.debounce(function (value) {
        if (value) {
          PlacesAPI.search({q: value}, Vue.config.token).then(response => {
            this.placeOptions = response.results.map(place => {
              let region = ''
              if (place.county) {
                region = `${place.county} - ${place.region}`
              } else if (place.region) {
                region = place.region
              }
              return {
                value: place.id,
                label: `${place.name} ${region ? `- ${region} ` : ' '}- ${place.country}`
              }
            })
          })
        }
      }, 800)
    }

  }
</script>
<style>
</style>
